module.exports = __webpack_public_path__ + "assets/logo--white.9fbb2734068a0dc8366ad6fcc2de16e2.svg";


//////////////////
// WEBPACK FOOTER
// ../static/images/logo--white.svg
// module id = 432
// module chunks = 0